module.exports = __webpack_public_path__ + "static/media/warning-notification-icon.46cf3e07.svg";